import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { DipRegistrationLoggingNames } from '../../core/enum/dip-registration-logging-names.enum';
import { DiprsSpaLoggerService } from '../../core/services/logger/diprs-spa-logger.service';
import { LoggerEventEnum } from '../../core/models/dip-registration-log-information.model';
import {WebMetricsService} from '../../core/services/web-metrics/web-metrics.service';

@Component({
    selector: 'dip-registration-primary-account-modal',
    templateUrl: './dip-registration-primary-account-modal.component.html',
    styleUrls: ['./dip-registration-primary-account-modal.component.scss'],
    standalone: false
})
export class DipRegistrationPrimaryAccountModalComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  constructor(private spaLoggerService: DiprsSpaLoggerService,
              private webMetricsService: WebMetricsService) {
  }

  ngOnInit() {
    this.webMetricsService.submitErrorAndWarningTag('accountHolderPopupTag');
  }

  closeBtnClick() {
    this.spaLoggerService.info(LoggerEventEnum.USER_ACTION, DipRegistrationLoggingNames.ACCOUNT_NUMBER_POPUP, { id: 'CLOSE'});
    this.close.emit();
  }

}
